import React from 'react';
import { IconMapPin } from '@tabler/icons-react';
import { BoardClickUpFilterChipDropdown } from './BoardClickUpFilterChipDropdown';

/** Chip "Área" estilo ClickUp — submenu Board (teste A/B ao lado do chip legado). */
export function BoardToolbarAreaClickUpChip(props) {
  return (
    <BoardClickUpFilterChipDropdown
      {...props}
      label="Área"
      icon={IconMapPin}
      pickerMode="simple"
      pickerWidth={238}
      pickerMaxHeight={320}
      searchPlaceholder="Buscar"
      countLabel="áreas"
      listAriaLabel="Áreas"
      popoverClassName="board-search-filters-popover--area"
      emptyMessage="Nenhuma área encontrada"
    />
  );
}
